// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ob6T","title":"Info_title__3NgsA","selects":"Info_selects__10VLw","requiredAsterisk":"Info_requiredAsterisk__31bl0"};